import React, { useEffect, useState } from 'react'
import {
  Box,
  Checkbox,
  FormLabel,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import { RoundedButton } from 'common/Button/Button'
import { FormikProps } from 'formik'
import { IDeliveryDetails } from 'types/api/v1/org.type'

interface AddressProps {
  setNextPage: (value: void) => void
  setPreviousPage: (value: void) => void
  formik: FormikProps<IDeliveryDetails>
}

function DeliveryBillingAddress({
  setNextPage,
  setPreviousPage,
  formik
}: AddressProps) {
  const [billingDeliverySame, setBillingDeliverySame] = useState(false)

  useEffect(() => {
    if (
      formik.values.formattedBillingAddress ===
      formik.values.formattedDeliveryAddress
    ) {
      setBillingDeliverySame(true)
    }
  }, [])

  const handleBillingDeliverySame = (e) => {
    setBillingDeliverySame(e.target.checked)
    if (e.target.checked) {
      formik.setFieldValue(
        'formattedBillingAddress',
        formik.values.formattedDeliveryAddress
      )
    }
  }

  return (
    <>
      <Typography variant='h4'>Delivery Address</Typography>
      <Typography variant='subtitle1'>
        Fill the address for item delivery
      </Typography>
      <Box sx={{ height: '60vh' }}>
        <Box>
          <Stack direction='row' sx={{ gap: '4vw' }}>
            <Stack sx={{ margin: '24px 8px', width: '40%' }}>
              <FormLabel className='formSectionHeader'>
                Confirm Your Delivery Address
              </FormLabel>
              <TextField
                onChange={(e) => {
                  formik.handleBlur(e)
                  formik.handleChange(e)
                }}
                variant='standard'
                fullWidth
                placeholder='Enter your postal code or address'
                name='formattedDeliveryAddress'
                value={formik.values.formattedDeliveryAddress || ''}
                error={
                  formik.touched.formattedDeliveryAddress &&
                  Boolean(formik.errors.formattedDeliveryAddress)
                }
                helperText={
                  formik.touched.formattedDeliveryAddress &&
                  formik.errors.formattedDeliveryAddress
                }
              />
            </Stack>
          </Stack>
          <Stack direction='row' sx={{ gap: '4vw' }}>
            <Stack sx={{ margin: '24px 8px', width: '40%' }}>
              <FormLabel className='formSectionHeader'>Postal Code</FormLabel>
              <TextField
                onChange={(e) => {
                  formik.handleBlur(e)
                  formik.handleChange(e)
                }}
                variant='standard'
                fullWidth
                placeholder='123456'
                name='deliveryPostalCode'
                value={formik.values.deliveryPostalCode || ''}
                error={
                  formik.touched.deliveryPostalCode &&
                  Boolean(formik.errors.deliveryPostalCode)
                }
                helperText={
                  formik.touched.deliveryPostalCode &&
                  formik.errors.deliveryPostalCode
                }
              />
            </Stack>
          </Stack>
          <Stack sx={{ margin: '24px 8px' }}>
            <FormLabel className='formSectionHeader'>Billing Address</FormLabel>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                onChange={handleBillingDeliverySame}
                checked={billingDeliverySame}
              />
              <Typography>
                Billing address is the same as delivery address.
              </Typography>
            </Box>
            {!billingDeliverySame && (
              <>
                <Stack direction='row' sx={{ gap: '4vw' }}>
                  <Stack sx={{ margin: '24px 8px', width: '40%' }}>
                    <FormLabel className='formSectionHeader'>
                      Confirm Your Delivery Address
                    </FormLabel>
                    <TextField
                      onChange={(e) => {
                        formik.handleBlur(e)
                        formik.handleChange(e)
                      }}
                      variant='standard'
                      fullWidth
                      placeholder='Enter your postal code or address'
                      name='formattedBillingAddress'
                      value={formik.values.formattedBillingAddress || ''}
                      error={
                        formik.touched.formattedBillingAddress &&
                        Boolean(formik.errors.formattedBillingAddress)
                      }
                      helperText={
                        formik.touched.formattedBillingAddress &&
                        formik.errors.formattedBillingAddress
                      }
                    />
                  </Stack>
                </Stack>
                <Stack direction='row' sx={{ gap: '4vw' }}>
                  <Stack sx={{ margin: '24px 8px', width: '40%' }}>
                    <FormLabel className='formSectionHeader'>
                      Postal Code
                    </FormLabel>
                    <TextField
                      onChange={(e) => {
                        formik.handleBlur(e)
                        formik.handleChange(e)
                      }}
                      variant='standard'
                      fullWidth
                      placeholder='123456'
                      name='billingPostalCode'
                      value={formik.values.billingPostalCode || ''}
                      error={
                        formik.touched.billingPostalCode &&
                        Boolean(formik.errors.billingPostalCode)
                      }
                      helperText={
                        formik.touched.billingPostalCode &&
                        formik.errors.billingPostalCode
                      }
                    />
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <RoundedButton variant='secondary' onClick={() => setPreviousPage()}>
          Back
        </RoundedButton>
        <RoundedButton variant='filled' onClick={() => setNextPage()}>
          Next
        </RoundedButton>
      </Box>
    </>
  )
}

export default DeliveryBillingAddress
